import type {
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit,
} from '@markku/types'
import { createCrudHooks } from './base'
import { trpc } from '../trpc'

const crudHooks = createCrudHooks<
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit
>('visit')

export const visitHooks = {
  ...crudHooks,

  useGetAvailableTimeSlots: () => {
    return trpc.visit.getAvailableTimeSlots.useQuery({})
  },
}
